import apiClient from "./apiClient";

export function listProjectsRequest(params = {}) {
  return apiClient.get("/projects", { params });
}

export function listAllProjectsRequest() {
  return apiClient.get("/projects/all");
}

export function getProjectRequest(projectId) {
  return apiClient.get(`/projects/${projectId}`);
}

export function createProjectRequest(payload) {
  return apiClient.post("/projects", payload);
}

export function updateProjectRequest(projectId, payload) {
  return apiClient.patch(`/projects/${projectId}`, payload);
}

export function deleteProjectRequest(projectId) {
  return apiClient.delete(`/projects/${projectId}`);
}
